import { Assets } from "../Assets";
import { LevelObject } from "../LevelObject";
import { Obstacle } from "../components/Obstacle";
import { InfiniteSupply } from "../components/InfiniteSupply";
import { Direction, dirRotation } from "../Direction";
export class Fridge extends InfiniteSupply(Obstacle(LevelObject)) {
    constructor(levelMap, position, foodType, dir = Direction.South) {
        super(levelMap, Assets.objects.Fridge.clone(), position);
        this.model.quaternion.copy(dirRotation(dir));
        this.foodType = foodType;
    }
    get type() {
        return 'fridge';
    }
}
